/* GTG UX quick wins 2026-09-17 — facets slim + Shop now → all-products */
(function () {
  var HIDE = [
    '/collections/gtg-minis-printable-heroes',
    '/collections/trash-mob-minis',
    '/collections/monsters-foes',
    '/collections/heroes'
  ];
  var scheduled = false;

  function pathOf(href) {
    try { return new URL(href, window.location.origin).pathname.replace(/\/$/, ''); }
    catch (e) { return ''; }
  }

  function shouldHide(pathname) {
    return HIDE.indexOf(pathname) !== -1;
  }

  function slimFacets(root) {
    (root || document).querySelectorAll('li.facets__item a[href*="/collections/"], li.list-menu__item a[href*="/collections/"]').forEach(function (a) {
      if (shouldHide(pathOf(a.href))) {
        var li = a.closest('li');
        if (li && li.style.display !== 'none') li.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function fixAllLinks(root) {
    (root || document).querySelectorAll('a[href*="/collections/all"]').forEach(function (a) {
      try {
        var u = new URL(a.href, window.location.origin);
        if (u.pathname === '/collections/all' || u.pathname === '/collections/all/') {
          u.pathname = '/collections/all-products';
          a.setAttribute('href', u.pathname + u.search + u.hash);
        }
      } catch (e) {}
    });
  }

  function run() {
    slimFacets(document);
    fixAllLinks(document);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; run(); }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);

  if (document.documentElement) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
/* resave 2026-10-12 */
